import { render, staticRenderFns } from "./AppEditorMixin.vue?vue&type=template&id=0a00136c&"
import script from "./AppEditorMixin.vue?vue&type=script&lang=js&"
export * from "./AppEditorMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports